import {Icon} from '@iconify/react'

export const WhatsappWidget = () => {
    return (
        <div className="whatsapp__widget">
            <a href="https://wa.me/5491160140192?text=Hola%20los%20contacto%20desde%20la%20web." target={'_blank'} rel={'noreferrer'}><Icon icon={'bi:whatsapp'} /></a>
        </div>
    )
}